import { render, staticRenderFns } from "./CustomerFormArchEmbeddable.vue?vue&type=template&id=6dcdc63e&"
import script from "./CustomerFormArchEmbeddable.vue?vue&type=script&lang=js&"
export * from "./CustomerFormArchEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports